import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/botiboti.html',
        name: 'Home',
        component: Home,
        meta: { title: 'ぼちぼちでんなー', desc: 'ぼちぼちでんなー' },
        props: { pageType: 'normal' }
    },
    {
        path: '/botiboti_light.html',
        name: 'HomeLight',
        component: Home,
        meta: { title: 'ぼちぼちでんなー（軽量版）', desc: 'ぼちぼちでんなー（軽量版）' },
        props: { pageType: 'light' }
    },
    {
        path: '*',
        redirect: '/botiboti.html',
        meta: { title: 'ぼちぼちでんなー', desc: 'ぼちぼちでんなー' },
        props: { pageType: 'normal' }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
